export default {
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setSales(state, sales) {
    state.sales = sales;
  },
  setSale(state, sale) {
    state.sale = sale;
  },
  setTotalAmount(state, totalAmount) {
    state.totalAmount = totalAmount;
  },
  setTotalCount(state, totalCount) {
    state.totalCount = totalCount;
  },
  setEvents(state, events) {
    state.events = events;
  },
  setParticipants(state, participants) {
    state.participants = participants;
  },
  setTicketsOverview(state, ticketsOverview) {
    state.ticketsOverview = ticketsOverview;
  },
  setLots(state, lots) {
    state.lots = lots;
  },
  setLot(state, lot) {
    state.lot = lot;
  },
  setTickets(state, tickets) {
    state.tickets = tickets;
  }
};
